export class MessageManager {
    constructor() {
        this.eventHandlers = {
            show: [],
            hide: []
        };
    }
    on(event, handler) {
        if (event === "show") {
            this.eventHandlers.show.push(handler);
        }
        if (event === "hide") {
            this.eventHandlers.hide.push(handler);
        }
    }
    trigger(event, data) {
        if (event === "show") {
            this.eventHandlers.show.forEach(h => h(data));
        }
        if (event === "hide") {
            this.eventHandlers.hide.forEach(h => h(data));
        }
    }
    show(message) {
        this.trigger("show", message);
    }
    hide() {
        this.trigger("hide");
    }
}
